// JavaScript Document

import React from "react"
import ImageBlock from "./ImageBlock"
import TableOfContents from "./TableOfContents"
import '../styles/block2.css'


export default function ContentGridNew(props) {
    
    return(
    
        <div class={props.divClass}>
        
            <div class="row">
        
                <TableOfContents title={props.contentsTitle} style={props.elementClass} elementClass={props.contentDisplay} data={props.data} />
        
                {/*<ImageBlock style={props.imageClass} src={props.imageSrc}/>*/}
        
    
            </div>
        
        </div>
    
    )
    
}

